import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { placeholder } from 'src/app/models/placeholder';
import { DynamicFormService } from 'src/app/services/dynamic-form/dynamic-form.service';
import { PageStateService } from 'src/app/services/page-state.service';
import { UserGuestListComponent } from '../../user-guest-list/user-guest-list.component';
import { AccountService } from 'src/app/services/user/account.service';
import { AnalyticsService } from 'src/app/services/analytics/analytics.service';

@Component({
  selector: 'app-dynamic-form-modal',
  templateUrl: './dynamic-form-modal.component.html',
  styleUrls: ['./dynamic-form-modal.component.scss'],
})
export class DynamicFormModalComponent implements OnInit {
  @Input() catlogType: string;
  @Input() selectedPassenger: any;
  @Input() offersObject: any;
  @Input() selectedLocation?: string;
  @Input() locationList?: any;
  @Input() priceInfo?: any;
  @Input() airportCode?: any;
  @Input() serviceObject?: any;
  @Input() travel_date?: any;
  @Input() access_time?: any;
  @Input() selectedLengthOfStay?: any;
  @Output() guestSelected = new EventEmitter<any>();
  public imagePlaceholder = placeholder;
  public userGuestList: any = [];
  public selectedGuest: any = [];
  public currentHeaderData: any = {
    prevPageLink: '/my-activities',
    title: 'activities.cashback.header',
  };
  constructor(
    private dynamicFormService: DynamicFormService,
    private modalController: ModalController,
    private pageStateService: PageStateService,
    private accountService: AccountService,
    private analyticsService: AnalyticsService
  ) {}

  ngOnInit() {}
  closeModal() {
    this.analyticsService.trackUnified('modal_closed', {
      flow: 'shared',
      outcome: 'success',
      legacy_event_name: 'button_clicked',
      component: 'dynamic-form-modal',
      button: 'Close-Button',
    });
    this.modalController.dismiss();
  }

  ionViewDidEnter() {}

  submitRequest(data) {
    this.pageStateService.setReloadAll();
    this.modalController.dismiss(data);
  }



}
